import { Square, SquareCheck } from "lucide-react";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";
import { EntryValueChip } from "./EntryValueChip";

export interface CheckboxEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: boolean | string | null;
}

export function CheckboxEntryValue({ value, inputLabel, size, ...props }: CheckboxEntryValueProps) {
    // Handle various formats the value might come in
    const isChecked = value === true || value === "true" || value === "Yes";

    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} {...props}>
            {isChecked ? (
                <EntryValueChip icon={SquareCheck} tone="positive" size={size}>
                    Ticked
                </EntryValueChip>
            ) : (
                <EntryValueChip icon={Square} tone="muted" size={size}>
                    Not ticked
                </EntryValueChip>
            )}
        </BaseEntryValue>
    );
}
